// API configuration - uses relative URLs in production (Vercel)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;
export default API;
